<div class="modal fade" tabindex="-1" role="dialog" id="detalhe-produtivo-filtro">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 translate class="modal-title">{{'rmpv.produtividade.filtros.definirFiltros'}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container striped-rows">
              <div class="row ptb5">
                <div translate class="col col-4">
                  {{'rmpv.produtividade.filtros.dealer'}}
                  </div>
                  <div class="col col-8">
                    <select class="form-control form-control-sm" type="number" [(ngModel)]="Dealer">
                      <option translate value="">{{'rmpv.produtividade.filtros.dealerPlaceHolder'}}</option>
                      <option *ngFor="let item of dealer" [value]="item.id">{{item.descricao}}</option>
                    </select>
                </div>
              </div>       

            <div class="row ptb5">
              <div translate class="col col-4">
                {{'rmpv.produtividade.filtros.dataInicial'}}
              </div>
              <div class="col col-8">
                <div class="input-group input-group-sm ">
                    <input class="form-control" class="form-control" placeholder="{{'rmpv.produtividade.filtros.dataInicialPlaceHolder' | translate}}" [(ngModel)]="InicialData" [(ngModel)]="dataInicial" 
                    [maxDate]="max" ngbDatepicker #dataInicialView="ngbDatepicker" (click)="dataInicialView.toggle()"> 
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" (click)="dataInicialView.toggle()" type="button">
                        <em class="fa fa-calendar"></em>
                      </button>
                    </div>
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" (click)="limparDataInicial(dataInicialView)" type="button">
                        <em class="fa fa-trash"></em>
                      </button>
                    </div>
                  </div>
              </div>
            </div>  
            <div class="row ptb5">
              <div translate class="col col-4">
                {{'rmpv.produtividade.filtros.dataFinal'}}
              </div>
              <div class="col col-8">
                <div class="input-group input-group-sm ">
                    <input class="form-control" class="form-control" placeholder="{{'rmpv.produtividade.filtros.dataFinalPlaceHolder' | translate}}"  [(ngModel)]="FinalData" [(ngModel)]="dataFinal"  
                    [maxDate]="max" ngbDatepicker #dataFinalView="ngbDatepicker" (click)="dataFinalView.toggle()">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" (click)="dataFinalView.toggle()" type="button">
                        <em class="fa fa-calendar"></em>
                      </button>
                    </div>
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" (click)="limparDataFinal(dataFinalView)" type="button">
                        <em class="fa fa-trash"></em>
                      </button>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" (click)="Dealer() || limparDataInicial(dataInicialView) || limparDataFinal(dataFinalView)">
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn btn-info" data-dismiss="modal">OK</button>
        </div>
      </div>
    </div>
  </div>  
  
  